export default __webpack_public_path__ + "navigation-examples-advanced-960-8edbead28ae3597d1c0fb048a6b4ffdc.webp";